
import './App.css';
import React, { useState, useEffect } from "react";
import axios from "axios";
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Route, Routes, Redirect } from "react-router-dom";
import { Helmet } from "react-helmet";
import NavHeader from "./NavHeader";
import Customers from "./Customers";
import CustomerNew from "./CustomerNew";
import CustomerShow from "./CustomerShow";
import Login from './Login/Login';
import HaDeviceNew from './HaDeviceNew';
import HaDevices   from './HADevices';
import HaDeviceShow from './HADeviceShow';

function App() {
  
  axios.defaults.withCredentials = true;

  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error.response.status === 401) {
        localStorage.removeItem("user");
        if (window.location.pathname !== '/login') {
          window.location = "/login";
        }
      }
      return Promise.reject(error)
    }
  );

  if (!JSON.parse(localStorage.getItem('user'))) {
    return <Login />;
  }  

  return (
    <div className="font-body bg-gray-100 min-h-screen flex flex-col text-gray-900 pb-10">
      <Helmet
        titleTemplate={`%s`}
        defaultTitle={process.env.REACT_APP_NAME}
      />
      <NavHeader />

      <Router>
        <Routes>
          <Route path="/"            element={<Customers />} />
          <Route path="customerNew"  element={<CustomerNew />} />
          <Route path="customer/:id" element={<CustomerShow />} />

          <Route path="hadevices"      element={<HaDevices />} />
          <Route path="hadeviceNew"    element={<HaDeviceNew />} />
          <Route path="hadevice/:id"   element={<HaDeviceShow />} />

        </Routes>
        <div className="flex flex-grow mt-4">
        </div>
      </Router>
    </div>
  );
}

export default App;
